const MilestoneStatusBadge = ({ status = "IN PROGRESS" }) => {
  const isCompleted = status.toUpperCase().startsWith("COMPLETE");

  return (
    <div
      className={`milestone-status-badge ${isCompleted ? "milestone-status-badge-completed" : ""}`}
    >
      <div className="milestone-status-dot" />
      <span className="milestone-status-text">{status}</span>
    </div>
  );
};

export default MilestoneStatusBadge;
